<script lang="ts" setup>
  import { computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { route as routes } from '../../../../shared/config/routes.ts';
  import { HostErrorCode, hostErrorCodes } from '../../model/hostErrorCode.ts';
  import HostErrorView from './HostErrorView.vue';

  const currentRoute = useRoute();
  const router = useRouter();

  const code = computed(() => currentRoute.query.code as HostErrorCode);

  if (!hostErrorCodes.includes(code.value)) {
    router.replace({ name: routes.index });
  }
</script>

<template>
  <HostErrorView :code="code" @sign-in="router.push({ name: routes.spotifySignIn })" />
</template>
